export const OPPORTUNITY_STAGE_OPTIONS = [
  "Closed Won",
  "Closed Cancelled",
  "Written Confirmation of Award",
  "Proposal Sent",
  "Rebid Sent",
  "Closed Not Bidding",
  "On Hold by Client",
  "RFP In House",
  "RFI Sent",
  "WCA Rebid Sent",
  "Closed Lost",
  "RFI Requested",
  "Rebid In House",
  "WCA Cancelled",
  "Verbal Award",
  "WCA Rebid in House",
  "Verbal Award Rebid Sent",
  "Drafting Proposal",
  "Developing Project Scope",
];

export const HEAD_CELLS = [
  {
    id: "Country",
    type: "text",
    label: "Country",
  },
  {
    id: "Central / Local",
    type: "text",
    label: "Central / Local",
  },
  {
    id: "Site Number - PI",
    type: "text",
    label: "Site Number - PI",
  },
  {
    id: "Site Selected Date",
    type: "date",
    label: "Site Selected Date",
  },
  {
    id: "Site Activated - Actual",
    type: "date",
    label: "Site Activated - Actual",
  },
  {
    id: "Site Activated - Forecast",
    type: "date",
    label: "Site Activated - Forecast",
  },
  {
    id: "Site Closed - Actual",
    type: "date",
    label: "Site Closed - Actual",
  },
  {
    id: "Site Closed - Forecast",
    type: "date",
    label: "Site Closed - Forecast",
  },
  {
    id: "Site Status",
    type: "text",
    label: "Site Status",
  },
];

export const HEAD_CELLS_NOT_INCLUDED = [
  {
    id: "Country",
    type: "text",
    label: "Country",
  },
  {
    id: "Central / Local",
    type: "text",
    label: "Central / Local",
  },
  {
    id: "Site Number - PI",
    type: "text",
    label: "Site Number - PI",
  },
  {
    id: "Site Selected Date",
    type: "date",
    label: "Site Selected Date",
  },
  {
    id: "Site Activated - Actual",
    type: "date",
    label: "Site Activated - Actual",
  },
  {
    id: "Site Activated - Forecast",
    type: "date",
    label: "Site Activated - Forecast",
  },
  {
    id: "Site Status",
    type: "text",
    label: "Site Status",
  },
];

export const TAB_VALUE = {
    SITES_INCLUDED: 0,
    CLOSED_SITES: 1,
    SITES_NOT_INCLUDED: 2,
};

export const ACTUAL_FIELDS = [
  "Central / Local",
  "Country",
  "Site Activated - Actual",
  "Site Activated - Forecast",
  "Site Closed - Actual",
  "Site Closed - Forecast",
  "Site Number - PI",
  "Site Selected Date",
  "Site Status",
];

export const ACTUAL_FIELDS_NOT_INCLUDED = [
  "Central / Local",
  "Country",
  "Site Activated - Actual",
  "Site Activated - Forecast",
  "Site Number - PI",
  "Site Selected Date",
  "Site Status",
];

export const SITES_INCLUDED_HEADERS_EXCEL_EXPORT = [
  "Project ID",
  "Country",
  "Central / Local",
  "Site Number - PI",
  "Site Selected Date",
  "Site Activated - Actual",
  "Site Activated - Forecast",
  "Site Closed - Actual",
  "Site Closed - Forecast",
  "Site Status",
];

export const SITES_NOT_INCLUDED_HEADERS_EXCEL_EXPORT = [
  "Project ID",
  "Country",
  "Central / Local",
  "Site Number - PI",
  "Site Selected Date",
  "Site Activated - Actual",
  "Site Activated - Forecast",
  "Site Status",
];
